"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ImageItem = /** @class */ (function (_super) {
    __extends(ImageItem, _super);
    function ImageItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ImageItem.prototype.render = function () {
        var _a = this.props, isAccessory = _a.isAccessory, image = _a.image, width = _a.width, height = _a.height, className = _a.className, isParts = _a.isParts;
        if (isAccessory) {
            if (this.props.isSlider || this.props.isAccessoryList) {
                return (React.createElement("img", { src: !image.match(/\.(jpeg|jpg|gif|png)$/) ? image + "-218.png" : image, 
                    // onError={(event) => { var dom = $(event.target); dom.prop("src") != image ? dom.prop("src", image) : "" }}
                    onError: function (event) {
                        // $(".left_column > img:first-child").css("height", "70%"); //cart
                        // $("#pcg_shop_addtocart > div > div > div > div > div > img").css("height", "70%"); //gouwukuang
                        // $("li>img").css("height", "70%"); 
                        // $('.product_img>img').css({"height": "70%", "margin-top": "20px"}); 
                        // $('div.imgs_carousel > ul > li > img').css({"height": "70%", "margin-top": "20px"});
                        var dom = $(event.target);
                        decodeURI(dom.prop("src")) != image ? dom.prop("src", image) : (dom.prop({ "src": "/msa/parts/images/pcg/carbon-fpo.jpg", "height": "70%", "margin-top": "20px" }), dom.css({ "height": "70%", "margin-top": "20px" }));
                    }, alt: "product image", width: width, height: height, className: className }));
            }
            return (React.createElement("img", { src: !image.match(/\.(jpeg|jpg|gif|png)$/) ? image + "-218.png" : image, 
                // onError={(event) => { var dom = $(event.target); dom.prop("src") != image ? dom.prop("src", image) : "" }}
                onError: function (event) {
                    var dom = $(event.target);
                    decodeURI(dom.prop("src")) != image ? dom.prop("src", image) : (dom.prop("src", "/msa/parts/images/pcg/carbon-fpo.jpg"), dom.css("height", "70%"));
                }, alt: "product image", width: width, height: height, className: className }));
        }
        else if (isParts) {
            return (React.createElement("img", { src: image.substring(0, image.lastIndexOf(".")) + "-218" + image.substring(image.lastIndexOf(".")), onError: function (event) { var dom = $(event.target); dom.prop("src") != image ? dom.prop("src", image) : ""; }, alt: "product image", width: width, height: height, className: className }));
        }
        else {
            return (React.createElement("img", { src: image.substring(0, image.lastIndexOf(".")) + "-218" + image.substring(image.lastIndexOf(".")), onError: function (event) { var dom = $(event.target); dom.prop("src") != image ? dom.prop("src", image) : ""; }, alt: "product image", width: width, height: height, className: className }));
        }
    };
    return ImageItem;
}(React.Component));
exports.ImageItem = ImageItem;
